<script lang="ts" setup>
export interface ProductsItemPopularProps {
    title: string
    to: VNuxtLinkTo
    icon?: string
}

const props = defineProps<ProductsItemPopularProps>()
</script>

<template>
  <VNuxtLink
    :to="props.to"
    :label="props.title"
    class="product-box-simple translate-y-hover transition h-100 d-flex align-items-center fs-bigger fw-bold rounded text-decoration-none py-3 px-4 p-md-6 h-100"
  >
    <img
      v-if="props.icon"
      :src="props.icon"
      alt=""
      width="24"
      height="24"
      loading="lazy"
      decoding="async"
      class="me-3 transition d-flex align-items-center justify-content-center"
    >
    {{ props.title }}
  </VNuxtLink>
</template>

<style lang="scss">
@import './ProductBoxSimple.vars.scss';
</style>
<style scoped lang="scss">
@import './ProductBoxSimple.scss';
</style>
